export default {
	app: {
		dimmer: null,
        systemInfoMessage: [],
		retryPolicy: false,
		systemToggles: {},
		systemUtcDateTime: null
	},
	admin: {
		loaded: false,
		loading: false,
		systemInfoMessages: [],
		userSearch: {
			search: '',
			results: []
		},
		pendingVerifications: [],
		chatSchedule: {
			id: null,
			mode: 3, // 1=off, 2=on, 3=use time schedule
			startTime: '7:30 am',
			endTime: '5:30 pm',
			closedWeekends: true
		},
		systemToggles: {},
		error: null
	},
	session: {
		token: null,
		refresh: null,
		requiresLogin: false
	},
	profile: {
		name: null,
		email: null,
		phoneNumber: null,
		policies: [],
		loaded: false
	},
	payment: {
		banks: {},
		recurring: {
			policyId: null,
			policyNumber: null
		},
		scheduled: [],
		settings: {
			fiservApiKey: null,
			fiservUrl: null,
			useFiservForCreditCard: false,
			useFiservForRecurringCreditCard: false,
			isWalletEnabled: false,
			isScheduledPaymentEnabled: false,
			walletsLoaded: false,
			wallets: []
		},
		auth: {
			authToken: null,
			sessionToken: null,
			sessionId: null
		}
	},
	claim: {
		loading: false
	},
	policy: {
		loaded: false,
		items: [],
		add: {
			policyHolder: null,
			policyNumber: null,
			driversLicenseNumber: null,
			zip: null,
			dateOfBirth: null,
			employeeIdentificationNumber: null,
			loading: false,
			error: null
		},
		edit: {
			loading: false,
			error: null
		}
	},
	auth: {
		username: null,
		password: null,
		rememberMe: false,
		loading: false,
		error: null,
		authenticated: false,
		passwordSent: false,
		legacyUsername: null
	},
	registration: {
		policy: {
			policyHolder: null,
			policyNumber: null,
			driversLicenseNumber: null,
			zip: null,
			dateOfBirth: null,
			employeeIdentificationNumber: null,
			verifiedPart1: false,
			verifiedPart2: false,
			requiresStaffVerification: false,
			staffVerificationRequestCompleted: false,
			loading: false,
			error: null,
			registrationFailureCount: 0
        },
		user: {
			username: null,
			password: null,
			confirmPassword: null,
			oldPassword: null,
			loading: false,
			error: null,
			created: false,
			passwordReset: false,
			passwordChanged: false,
			emailChanged: false,
			confirmUsername: null,
			oldUsername: null,
			agreeTerms: false
		}
	}
};
